import "./CloudAccountingPage3.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyFeatures from "./sections/KeyFeatures";
import ImageGrid from "./sections/ImageGrid";
import OurTeam from "./sections/OurTeam";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CloudAccountingPage3() {
  return <div>
      <Header />
      <Hero />
      <KeyFeatures />
      <ImageGrid />
      <OurTeam />
      <CallToAction />
      <Footer />
    </div>;
}